export const WORKLOAD_VIEWS = {
  DASHBOARD: 'dashboard',
  LIST: 'list',
  VERTICAL_AUTOSCALING: 'vertical-autoscaling',
  HORIZONTAL_AUTOSCALING: 'horizontal-autoscaling',
  META: 'meta',
  EVENTS: 'events',
} as const;

export type WorkloadView = (typeof WORKLOAD_VIEWS)[keyof typeof WORKLOAD_VIEWS];

export const WORKLOAD_CATEGORIES = {
  DEFAULT: 'default',
  AUTOSCALING: 'autoscaling',
  SAVINGS: 'savings',
  COMPUTE: 'compute',
  RELIABILITY: 'reliability',
  NETWORK: 'network',
  GPU_UTILIZATION: 'gpu',
} as const;

export type WorkloadCategory =
  (typeof WORKLOAD_CATEGORIES)[keyof typeof WORKLOAD_CATEGORIES];

export type WorkloadCategoryFilterOption = {
  value: Exclude<WorkloadCategory, typeof WORKLOAD_CATEGORIES.DEFAULT>;
  label: string;
};

/** Exhaustive labels for customize-drawer View filter (excludes Default). */
const WORKLOAD_CATEGORY_FILTER_LABELS = {
  [WORKLOAD_CATEGORIES.AUTOSCALING]: 'Autoscaling',
  [WORKLOAD_CATEGORIES.SAVINGS]: 'Savings',
  [WORKLOAD_CATEGORIES.COMPUTE]: 'Compute',
  [WORKLOAD_CATEGORIES.RELIABILITY]: 'Reliability',
  [WORKLOAD_CATEGORIES.NETWORK]: 'Network',
  [WORKLOAD_CATEGORIES.GPU_UTILIZATION]: 'GPU utilization',
} as const satisfies Record<
  Exclude<WorkloadCategory, typeof WORKLOAD_CATEGORIES.DEFAULT>,
  string
>;

/** Category options for customize-drawer View filter (excludes Default). */
export const WORKLOAD_CATEGORY_FILTER_OPTIONS: WorkloadCategoryFilterOption[] =
  (
    Object.entries(WORKLOAD_CATEGORY_FILTER_LABELS) as Array<
      [WorkloadCategoryFilterOption['value'], string]
    >
  ).map(([value, label]) => ({ value, label }));
